/**
 * Created by staffanrantzow on 12/04/16.
 */

export default class CustomerEntity {

  constructor (
    id,
    contact,
    email,
    name,
    phone,
    sendToEmail,
    sendToEmailSecondary,
    userId,
    vatNr,
    address,
    payTerms,
    messageType,
    eInvoiceAddress,
    poNumber
    ) {
    this.id = id;
    this.contact = contact;
    this.email = email;
    this.name = name;
    this.phone = phone;
    this.sendToEmail = sendToEmail;
    this.sendToEmailSecondary = sendToEmailSecondary;
    this.userId = userId;
    this.vatNr = vatNr;
    this.address = address;
    this.payTerms = payTerms;
    this.messageType = messageType;
    this.eInvoiceAddress = eInvoiceAddress;
    this.poNumber = poNumber;
  }

}



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/customers/customer-entity.js
 **/